import React from 'react';
import * as Utils from 'utils';
import {useNumberFormat} from "../../../hooks";

export default function CartOptionsAsap({
  optionAsap,
  totalPriceForAsap
}) {
  const {format} = useNumberFormat();

  return (
    <>
      {optionAsap && (totalPriceForAsap > 0) &&
        <div className="app-cart-options app-cart-options--no-borders">
          <div className="app-cart-option-list">
            <div className="app-cart-option-item">
              <div className="app-cart-line">
                <div className="app-cart-line-left">
                  <span className="app-cart-text-parameter-light">{Utils.replacer(optionAsap, 'priceLabel')}</span>
                </div>
                <div className="app-cart-line-right">
                  <span className="app-cart-text-value-light">${format(totalPriceForAsap)} &#215; 2 = </span>
                  <span className="app-cart-text-value">${format(totalPriceForAsap * 2)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}
